var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"d-inline text-h5 font-weight-bold",class:_vm.dark ? 'white--text' : 'black--text'},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }